var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleanUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    transform: "matrix(-1 0 0 1 24 -9.53674e-07)",
    fill: "#58914A"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -1 22.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 4 25.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 9 28.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -4 17.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 35,
    y2: -1.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 -8 13.7487)",
    stroke: "#457C39",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.48547 5.04577L5.83903 4.69222",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91063 7.47093L8.26418 7.11737",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83064 8.55092L7.1842 8.19737",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40549 6.12577L4.75904 5.77221",
    stroke: "white",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63375 5.10803C7.51935 5.00593 7.39689 4.91548 7.27191 4.83872C7.1052 4.73639 6.9351 4.66057 6.77266 4.61706C6.61032 4.57365 6.45788 4.56265 6.3245 4.5846C6.29238 4.5899 6.2615 4.59765 6.23197 4.6067L6.45087 4.8256C6.52516 4.82418 6.61141 4.83301 6.70775 4.85874C6.80947 4.886 6.91878 4.92873 7.02953 4.98718L7.14071 5.0514C7.25251 5.12005 7.36292 5.20195 7.46664 5.29447L7.56815 5.39045C7.6674 5.48973 7.75751 5.59679 7.8347 5.70672L7.90789 5.81859C7.97661 5.93063 8.03041 6.04163 8.0681 6.14728L8.09986 6.25086C8.12572 6.34758 8.13511 6.43392 8.1337 6.50843L8.3526 6.72733L8.37469 6.6348C8.39122 6.53457 8.38896 6.42321 8.36848 6.30541L8.34155 6.18595C8.30896 6.06429 8.25857 5.93847 8.19239 5.81306L8.12058 5.68738C8.01826 5.52071 7.89048 5.35927 7.74493 5.21368L7.63375 5.10803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46348 6.3738C4.29257 6.54472 4.27096 6.80879 4.39926 7.00288L4.46348 7.08091L5.8777 8.49513L5.95573 8.55934C6.14982 8.68764 6.41389 8.66604 6.5848 8.49513L8.35257 6.72736L8.17579 6.55058L6.40803 8.31835C6.32268 8.40369 6.19084 8.41466 6.09383 8.3508L6.05447 8.31835L4.64026 6.90414C4.54263 6.8065 4.54263 6.64821 4.64026 6.55058L6.40803 4.78281L6.23125 4.60604L4.46348 6.3738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.1,
    x2: 0.1,
    y2: -0.1,
    transform: "matrix(0 -1 -1 0 6.26723 4.82254)",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.13429,
    y1: 6.5396,
    x2: 8.23429,
    y2: 6.5396,
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.875,
    cy: 0.875,
    r: 0.775,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 7.65099 6.54285)",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6268 7.02174L2.73543 8.91311C2.66709 8.98145 2.66709 9.09198 2.73543 9.16032L3.79609 10.221C3.86443 10.2893 3.97496 10.2893 4.0433 10.221L5.93467 8.32961L4.6268 7.02174Z",
    stroke: "white",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-1_12_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33044 4.30616C9.07941 3.24467 11.1378 2.81075 13.1665 3.07591C15.1951 3.34107 17.0728 4.28949 18.4902 5.76485C19.9076 7.24021 20.78 9.15445 20.9637 11.1921C21.1473 13.2297 20.6313 15.2691 19.5005 16.9741C18.3698 18.6791 16.6919 19.948 14.7434 20.5717C12.7949 21.1953 10.6921 21.1365 8.78148 20.4048C6.87089 19.6732 5.26659 18.3124 4.233 16.5468C3.19941 14.7812 2.79822 12.7162 3.09555 10.692L3.39376 10.7358C3.10638 12.6922 3.49414 14.6881 4.49311 16.3946C5.49209 18.101 7.04266 19.4162 8.88926 20.1234C10.7359 20.8305 12.7683 20.8874 14.6516 20.2846C16.5348 19.6819 18.1565 18.4555 19.2494 16.8075C20.3422 15.1596 20.841 13.1885 20.6635 11.2191C20.486 9.24974 19.6428 7.39961 18.2729 5.97366C16.903 4.54771 15.0881 3.63105 13.1274 3.37477C11.1667 3.11849 9.17722 3.53788 7.48682 4.56382L7.33044 4.30616Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.33044 4.30616C9.07941 3.24467 11.1378 2.81075 13.1665 3.07591C15.1951 3.34107 17.0728 4.28949 18.4902 5.76485C19.9076 7.24021 20.78 9.15445 20.9637 11.1921C21.1473 13.2297 20.6313 15.2691 19.5005 16.9741C18.3698 18.6791 16.6919 19.948 14.7434 20.5717C12.7949 21.1953 10.6921 21.1365 8.78148 20.4048C6.87089 19.6732 5.26659 18.3124 4.233 16.5468C3.19941 14.7812 2.79822 12.7162 3.09555 10.692L3.39376 10.7358C3.10638 12.6922 3.49414 14.6881 4.49311 16.3946C5.49209 18.101 7.04266 19.4162 8.88926 20.1234C10.7359 20.8305 12.7683 20.8874 14.6516 20.2846C16.5348 19.6819 18.1565 18.4555 19.2494 16.8075C20.3422 15.1596 20.841 13.1885 20.6635 11.2191C20.486 9.24974 19.6428 7.39961 18.2729 5.97366C16.903 4.54771 15.0881 3.63105 13.1274 3.37477C11.1667 3.11849 9.17722 3.53788 7.48682 4.56382L7.33044 4.30616Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeDasharray: "0.5 0.5",
    mask: "url(#path-19-inside-1_12_3)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "#164A1B",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanUp);
export default __webpack_public_path__ + "static/media/CleanUp.fdf8846a73e0c09dfff8d36720361044.svg";
export { ForwardRef as ReactComponent };